import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'accent' | 'secondary' | 'peach' | 'outline' | 'ghost' | 'link';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-[background-color,border-color,color,box-shadow,transform] duration-200 ease-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-blue text-white hover:bg-brand-blue-dark shadow-subtle hover:shadow-subtle-hover',
    accent: 'bg-accent text-white hover:bg-accent-dark shadow-subtle hover:shadow-subtle-hover',
    secondary: 'bg-ink text-white hover:bg-accent-dark shadow-subtle',
    peach: 'bg-peach text-ink hover:bg-peach-dark shadow-subtle',
    outline: 'border-2 border-ink/15 bg-surface/60 hover:bg-surface hover:border-ink/30 text-ink',
    ghost: 'bg-transparent hover:bg-soft-panel text-ink rounded-full',
    link: 'bg-transparent underline-offset-4 hover:underline text-brand-blue p-0 h-auto rounded-none'
  };
  const sizes = {
    sm: 'h-10 px-5 text-sm',
    md: 'h-12 px-7 text-base',
    lg: 'h-14 px-8 text-base md:text-lg'
  };
  return <button ref={ref} className={cn(baseStyles, variants[variant], variant !== 'link' && sizes[size], fullWidth && 'w-full', className)} {...props} data-id="element-550" data-mp="1ldl5v6nqpwwq">
        {children}
      </button>;
});
Button.displayName = 'Button';